import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";

export default function WhatsAppButton() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-28 lg:bottom-6 right-6 z-50" data-testid="whatsapp">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            className="absolute bottom-20 right-0 w-80 glass-card overflow-hidden"
          >
            <div className="bg-gradient-to-r from-[#00E5FF] to-[#25D366] p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <MessageCircle size={20} className="text-white" />
                </div>
                <div>
                  <p className="text-white font-bold text-sm">SuperMajstri</p>
                  <p className="text-white/80 text-xs">Online teraz</p>
                </div>
              </div>
            </div>
            <div className="p-4">
              <p className="text-zinc-400 text-sm mb-4">
                Ahoj! 👋 Máte otázky? Napíšte nám na WhatsApp.
              </p>
              <a
                href="https://wa.me/421907649964?text=Dobrý%20deň%2C%20mám%20záujem%20o%20cenovú%20ponuku..."
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-[#25D366] hover:bg-[#20BD5A] text-white font-bold py-3 rounded-xl text-center transition-colors"
              >
                Začať chat
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setOpen(!open)}
        className="whatsapp-btn"
        data-testid="whatsapp-btn"
        aria-label={open ? "Zavrieť WhatsApp panel" : "Otvoriť WhatsApp kontakt"}
      >
        {open ? (
          <X size={24} className="text-white" />
        ) : (
          <MessageCircle size={24} className="text-white" />
        )}
      </motion.button>
    </div>
  );
}
